/**
 * @param {Array}  accounts - Bank account objects
 * @param {Object} prefs    - user.settings.bankAccountPreferences
 * @returns {Array} Sorted by user preference position (hidden accounts included)
 */
export const sortByPreferences = function(accounts, prefs) {
    if (!prefs) { prefs = {}; }
    return [...accounts].sort(function(a, b) {
        const posA = prefs[a.id] !== undefined ? prefs[a.id].sortPosition : 999;
        const posB = prefs[b.id] !== undefined ? prefs[b.id].sortPosition : 999;
        if (posA !== posB) { return posA - posB; }
        return (a.sortPosition || 0) - (b.sortPosition || 0);
    });
};

/**
 * @param {Array}  accounts - Bank account objects
 * @param {Object} prefs    - user.settings.bankAccountPreferences
 * @returns {Array} Hidden accounts removed, remainder sorted by user preference
 */
export const applyPreferences = function(accounts, prefs) {
    if (!prefs) { prefs = {}; }
    return sortByPreferences(accounts, prefs)
        .filter(function(a) { return !prefs[a.id] || !prefs[a.id].hidden; });
};
